import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100/80 border border-secondary-200/60 text-secondary-700 text-xs font-semibold mb-4 whitespace-nowrap">
            <i className="ri-question-answer-line text-sm"></i>
            常见问答
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">常见问题解答</h2>
          <p className="text-sm text-foreground-500 max-w-2xl mx-auto">关于黑料吃瓜网的使用和内容，这里有你想知道的答案。</p>
        </div>

        <div className="max-w-3xl mx-auto grid gap-4">
          {faqItems.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6">
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xs font-bold">Q</span>
                {item.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}